import React from 'react'
import WIDGET_ARROW from 'images/purple_arrow.svg'
import cx from 'classnames'

import './style.css'


export const TipTextType = Object.freeze({
  INTRO: 0,
  STUCK: 1
})

const TIP_TEXT_MAP = Object.freeze({
  [TipTextType.INTRO]: 'And we’ll be right here if you have any questions along the way!',
  [TipTextType.STUCK]: 'Stuck? Shoot us a message!'
})

const OnboardingWidgetTip = ({ tipTextKey = TipTextType.STUCK }) => {
  return (
    <div className={cx("onboarding-widget-tip", {'onboarding-widget-tip--stuck': tipTextKey===TipTextType.STUCK})} >
      {TIP_TEXT_MAP[tipTextKey]}
      <img src={WIDGET_ARROW} alt="purple-arrow"></img>
    </div>
  )
}

export default OnboardingWidgetTip



// WEBPACK FOOTER //
// ./src/components/OnboardingWidgetTip/index.js